(() => {
  const selector = '[data-testid="product-recommendations-section"]';

  const settle = (root) => {
    if (!root?.isConnected) return;
    const hasProducts = Boolean(root.querySelector('.sny-product-recommendations__grid .sny-home-product-card'));
    const performed = root.dataset.recommendationsPerformed === 'true';
    if (hasProducts) {
      root.hidden = false;
      root.classList.remove('hidden');
    } else if (performed) {
      root.hidden = true;
      root.classList.add('hidden');
      root.replaceChildren();
    }
  };

  const initialize = (root) => {
    if (root.dataset.seednaryRecommendationsReady === 'true') return;
    root.dataset.seednaryRecommendationsReady = 'true';
    const observer = new MutationObserver(() => settle(root));
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recommendations-performed'] });
    window.setTimeout(() => {
      if (!root.querySelector('.sny-product-recommendations__grid .sny-home-product-card')) {
        root.hidden = true;
        root.classList.add('hidden');
        root.replaceChildren();
      }
      observer.disconnect();
    }, 10000);
    settle(root);
  };

  const initializeAll = () => document.querySelectorAll(selector).forEach(initialize);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initializeAll, { once: true }) : initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
